import { useState } from "react";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Alert } from "@design-system/Alert/Alert";
import { Button } from "@design-system/Button/Button";
import { ToggleGroup } from "@design-system/ToggleGroup/ToggleGroup";
import { VStack } from "@design-system/VStack/VStack";
import { BooleanControl, VariantGrid, VariantItem } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./FeedbackPlayground.module.scss";
import gridStyles from "./playgroundControls.module.scss";

type AlertVariant = "default" | "cta" | "danger" | "warning";

const alertVariants: AlertVariant[] = ["default", "cta", "danger", "warning"];

export const AlertPlayground = () => {
    const [variant, setVariant] = useState<AlertVariant>("default");
    const [hasHeader, setHasHeader] = useState(true);
    const [hasAction, setHasAction] = useState(true);

    const alertContent = (
        <>
            Review this message before continuing.
            {hasAction ? (
                <>
                    {" "}
                    <Button type="button" variant="link" size="sm">
                        View details
                    </Button>
                </>
            ) : null}
        </>
    );

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Variant</h2>
                        <ToggleGroup.Root
                            value={variant}
                            onValueChange={(value) => {
                                if (
                                    value === "default" ||
                                    value === "cta" ||
                                    value === "danger" ||
                                    value === "warning"
                                ) {
                                    setVariant(value);
                                }
                            }}
                        >
                            {alertVariants.map((option) => (
                                <ToggleGroup.Item key={option} value={option}>
                                    {option}
                                </ToggleGroup.Item>
                            ))}
                        </ToggleGroup.Root>
                    </section>
                    <section>
                        <h2>Content</h2>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Header"
                                checked={hasHeader}
                                onChange={setHasHeader}
                            />
                            <BooleanControl
                                label="Action"
                                checked={hasAction}
                                onChange={setHasAction}
                            />
                        </div>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={variant}
                width="full"
                output={JSON.stringify(
                    {
                        variant,
                        header: hasHeader ? "Important update" : undefined,
                        showcaseHasAction: hasAction,
                    },
                    null,
                    2,
                )}
            >
                <VStack gap={16} className={gridStyles.fillWidth}>
                    <Alert
                        variant={variant}
                        header={hasHeader ? "Important update" : undefined}
                    >
                        {alertContent}
                    </Alert>
                    <VariantGrid title="All variants" columns="full">
                        {alertVariants.map((option) => (
                            <VariantItem key={option} label={option}>
                                <Alert
                                    variant={option}
                                    header={
                                        hasHeader
                                            ? "Important update"
                                            : undefined
                                    }
                                >
                                    {alertContent}
                                </Alert>
                            </VariantItem>
                        ))}
                    </VariantGrid>
                </VStack>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
